"use strict";
require.context("../images", true);
import "stylesheets/sortitions.scss";
